
<script>
import options from './CTABox.options'
export default options
</script>

<template>

    <article class="kb-cta-box">
        <h2 class="kb-cta-box__title">{{ getLabel("title") }}</h2>

        <ul class="kb-cta-box__link-list">
          <template v-for="(link, index) in result.links" :key="index">
                <template v-if="link.type === 'SocialMedia'">
                    <li>
                      <a
                        class="kb-cta-box__link"
                        :title="link.title"
                        :aria-label="link.ariaLabel"
                        :href="link.link"
                        :target="link.target"
                      >
                        <div class="kb-original-icon" v-html="link.svgIcon">
                        </div>
                      </a>
                    </li>
                </template>

                <template v-if="link.type === 'CopyLink'">
                    <button class="kb-cta-box__link"
                            :title="link.title"
                            :aria-label="link.ariaLabel"
                            :onClick="()=> {handleCopyLink(link.link)}">
                        <div class="kb-original-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 50 50"><circle cx="25" cy="25" r="25" fill="#005B78" /><path fill="#fff" fill-rule="evenodd" d="m26.3 23.7-.5-.6.5-.5.6.5a3.4 3.4 0 0 1 0 4.8l-5.3 5.3a3.4 3.4 0 0 1-4.8-4.8l3.7-3.7.5.6-3.7 3.7a2.6 2.6 0 1 0 3.7 3.7l5.3-5.3c1-1 1-2.7 0-3.7Z" clip-rule="evenodd" /><path fill="#fff" fill-rule="evenodd" d="m23.7 26.3.5.6-.5.5-.6-.5a3.4 3.4 0 0 1 0-4.8l5.3-5.3a3.4 3.4 0 0 1 4.8 4.8l-3.7 3.7-.5-.6 3.7-3.7a2.6 2.6 0 1 0-3.7-3.7l-5.3 5.3c-1 1-1 2.7 0 3.7Z" clip-rule="evenodd" /></svg>
                        </div>

                        <template v-if="displayCopyResponse">
                            <ActionResponseBox 
                            :actionResponseText='getLabel("linkCopiedResponseText")' 
                            :lifeTime="actionResponseLifeTime"
                            :fadeOut="actionResponseFadeOutTime"
                            />
                        </template>
                    </button>
                </template>
       
            </template>
        </ul>
        <a :href="result.extraLink" class="kb-cta-box__extra-link">
          <span class="kb-cta-box__extra-link__text">{{ getLabel("extraLinkText") }}</span>
          <span class="kb-cta-box__extra-link__icon">
            <svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="m12.167 4 3.623 4-3.623 4"
                stroke="#3C3C3C"
                stroke-linejoin="round"
              />
              <path d="M11.746 8H0" stroke="#3C3C3C" />
            </svg>
          </span>
        </a>
      
      </article>

</template>
